import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {CountMatchedRepositoryItemsRequest, CountMatchedRepositoryItemsResponse} from './contracts'

export async function apiCountMatchedRepositoryItems({
  repositoryId,
  query,
  memexNumber,
  advancedSearch,
}: CountMatchedRepositoryItemsRequest): Promise<CountMatchedRepositoryItemsResponse> {
  const apiData = getApiMetadata('count-issues-and-pulls-api-data')
  const url = new URL(apiData.url, window.location.origin)
  if (repositoryId) {
    url.searchParams.set('repositoryId', `${repositoryId}`)
  }
  url.searchParams.set('q', query)
  url.searchParams.set('memexNumber', `${memexNumber}`)
  if (advancedSearch) {
    url.searchParams.set('advanced_search', 'true')
  }
  const {data} = await fetchJSON<CountMatchedRepositoryItemsResponse>(url)

  return data
}
